import { Ban, FileText, Zap } from "lucide-react";
import React from "react";
import { Link } from "react-router-dom";

const PlanCard = ({
  onButtonClick,
  serviceName,
  isAssigned,
  serviceId,
  environment,
  status,
  description,
  serviceValue
}) => {
  const handleButtonClick = () => {
    if (!isAssigned) {
      onButtonClick();
    } else {
    }
  };

  const getStatusBadge = (status) => {
    if (!status) return null;

    // Normalize all possible variations
    const normalized = String(status).trim().toLowerCase();

    let finalStatus = "";

    if (normalized === "active" || status === 5) {
      finalStatus = "active";
    } else if (normalized === "inactive" || status === 4) {
      finalStatus = "inactive";
    } else if (
      normalized === "deprecated" ||
      normalized === "depreciate" || // ← added
      normalized === "depriciate" || // ← safe fallback if API misspells
      status === 18
    ) {
      finalStatus = "deprecated";
    } else {
      finalStatus = "unknown";
    }

    switch (finalStatus) {
      case "active":
        return (
          <span className="px-4 py-2 rounded-2xl bg-green-100 text-green-700  text-[14px] font-medium">
            Active
          </span>
        );

      case "inactive":
        return (
          <span className="px-4 text-[14px] py-2 rounded-2xl bg-orange-100  text-orange-700 font-thin">
            Inactive
          </span>
        );

      case "deprecated":
        return (
          <span className="px-4 text-[14px] py-2 rounded-2xl bg-red-100  text-red-700 font-semibold">
            Deprecated
          </span>
        );

      default:
        return (
          <span className="text-[14px] px-4 py-2 rounded-md bg-gray-100 text-gray-600 font-medium">
            Unknown
          </span>
        );
    }
  };

  const resolveStatus = (status) => {
    if (!status) return "unknown";

    const normalized = String(status).trim().toLowerCase();

    if (normalized === "active" || status === 5) return "active";
    if (normalized === "inactive" || status === 4) return "inactive";
    if (
      normalized === "deprecated" ||
      normalized === "depreciate" ||
      normalized === "depriciate" ||
      status === 18
    ) {
      return "deprecated";
    }

    return "unknown";
  };
  const badge = resolveStatus(status);

  return (
    <div
      className={`
      relative overflow-hidden w-full
      rounded-xl m-2
      bg-gradient-to-br ${
        isAssigned && badge === "active"
          ? "from-green-100/50 to-green-50"
          : badge === "unknown"
            ? "from-slate-100/50 to-slate-50"
            : badge === "inactive"
              ? "from-red-100/50 to-red-50"
              : badge === "deprecated"
                ? "from-red-100/50 to-red-50"
                : "from-yellow-100/50 to-yellow-50"
      }

      backdrop-blur-xl
      p-4
      shadow-md shadow-gray-700
      transition-transform duration-300 hover:-translate-y-1 hover:shadow-xl
    `}
    >
      {/* Soft glow accent */}
      <div className="absolute inset-0 pointer-events-none" />

      {/* STATUS BADGE */}
      <div className="absolute top-3 right-3">
        <span
          className="
      text-[10px] font-semibold uppercase tracking-wider
      px-2 py-0.5
      rounded-full
       backdrop-blur-md
    "
        >
          {getStatusBadge(status)}
        </span>
      </div>

      {/* TITLE */}
      <h2 className="text-sm font-semibold text-black/90 mb-2">
        {serviceName}
      </h2>

      {/* ASSIGNMENT + ENV */}
      <div className="flex items-center justify-between text-sm mb-3">
        <span className={isAssigned ? "text-green-700" : "text-red-700"}>
          {isAssigned ? "Assigned" : "Not Assigned"}
        </span>

        <span className="text-black/70">
          Env:
          <span
            className={`ml-1 font-medium ${
              environment === "PRODUCTION"
                ? "text-green-700"
                : "text-yellow-600"
            }`}
          >
            {environment}
          </span>
        </span>
      </div>

      <div className="text-gray-700 py-2">
        <strong>Description: </strong> {serviceValue || "N/A"}
      </div>

      {/* ACTIONS */}
      <div className="flex gap-2">
        <button
          className={`
        flex-1 rounded-lg px-3 py-1.5 text-sm font-medium
        transition-all flex items-center gap-2 duration-200 bg-gradient-to-br text-white

        ${
          isAssigned && badge === "active"
            ? "from-slate-800/50 to-slate-600 text-white cursor-not-allowed"
            : badge === "unknown"
              ? "from-slate-800 to-slate-600"
              : badge === "inactive"
                ? "from-red-800 to-red-600"
                : badge === "deprecated"
                  ? "from-red-800 to-red-600"
                  : "from-yellow-800 to-yellow-600"
        }

      `}
          onClick={handleButtonClick}
          disabled={isAssigned}
        >
          {!isAssigned && <Zap />}
          {isAssigned && <Ban />}

          {isAssigned ? "Assigned" : "Activate"}
        </button>

        <Link
          to={`/ApiLink?serviceId=${serviceId}`}
          className={`
        flex-1 rounded-lg flex bg-gradient-to-br items-center gap-2 px-3 py-1.5 text-sm font-medium text-center
              ${
                isAssigned && badge === "active"
                  ? "from-green-800 to-green-600"
                  : badge === "unknown"
                    ? "from-slate-800 to-slate-600"
                    : badge === "inactive"
                      ? "from-red-800 to-red-600"
                      : badge === "deprecated"
                        ? "from-red-800 to-red-600"
                        : "from-yellow-800 to-yellow-600"
              } text-white
 hover:bg-white/25
        transition-all duration-200
      `}
        >
          <FileText />
          API Docs
        </Link>
      </div>
    </div>
  );
};

export default PlanCard;
